import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { withTranslation } from 'react-i18next';
import Message from '../utility/Message';
import PropTypes from 'prop-types';

import {
  SITE_TITLE,
} from '../../constants';

class ThankYou extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    return (
      <>  
        <Helmet>
          <title>{t('gen:thankYou')} | { SITE_TITLE }</title>
        </Helmet>
        <Message />
      </>
    );
  }
}

ThankYou.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ThankYou);